import { createAsyncThunk } from '@reduxjs/toolkit';
import { Notification } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import { FindNotification } from './interface';

export const findNotification = createAsyncThunk(
  'notification/findNotification',
  async (values: FindNotification, { rejectWithValue }) => {
    try {
      const response = await Notification.find({
        query: values,
      });

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);